import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import { font } from 'assets/themes/theme-default'

const Title = styled.h4`
  color: ${props => props.theme.colors.color1.bg};
  font-weight: ${font.weight.base};
  font-size: ${font.size.lgxs};
  line-height: ${isMobile && 'normal'};
  margin: ${isMobile ? '0 0 10px 0' : '0 0 40px 0'};
`

const SmallTitle = styled(Title)`
  font-size: ${font.size.base};
  margin: ${isMobile ? '0 0 10px 0' : '0 0 10px 0'};
`

const TitleIcon = props => {
  const { title, small, cssId, ...rest } = props
  return (
    <>
      {small ? (
        <SmallTitle id={cssId} {...rest}>
          <span>{title}</span>
        </SmallTitle>
      ) : (
        <Title id={cssId} className="title-section" {...rest}>
          <span>{title}</span>
        </Title>
      )}
    </>
  )
}

TitleIcon.defaultProps = {
  title: null,
  cssId: null
}
TitleIcon.propTypes = {
  small: PropTypes.bool,
  title: PropTypes.string,
  cssId: PropTypes.string
}

export default TitleIcon
